export enum Breakpoints {
  Mobile = 420,
  Tablet = 768,
}
